/**
 * @Author: Nenad Brcic
 * @Date: 27.05.16
 * @Email: neno@neno.ch
 */

import React, { Component, PropTypes} from 'react';
import NavigationItem from './NavigationItem';
import styles from './Navigation.scss';
import CSSModules from 'react-css-modules';
// import env from '../../../../config/env';

const Navigation = ({ links, handleClick }) => {
    const navItems = links.map((item) => (
        <NavigationItem
            key={ `${item.name}Link`}
            name={ item.name }
            icon={ item.icon }
            url={ item.url }
            handleClick={ handleClick }
        />
    ));

    return (
        <ul styleName="links">
            { navItems }
        </ul>
    )
};

Navigation.propTypes = {
    links: PropTypes.array.isRequired,
    handleClick: PropTypes.func.isRequired,
};

Navigation.defaultProps = {
    links: [],
};


export default CSSModules(Navigation, styles);


// WEBPACK FOOTER //
// ./app/components/Main/Navigation/index.jsx